export const translations = {
  appName: 'آشیانه',
  createAccount: 'ایجاد حساب جدید',
  welcomeBack: 'خوش آمدید',
  email: 'ایمیل',
  password: 'رمز عبور',
  signup: 'ثبت نام',
  login: 'ورود',
  processing: 'در حال پردازش...',
  alreadyHaveAccount: 'قبلاً حساب دارید؟',
  noAccount: 'حساب ندارید؟',
  chat: 'گفتگو',
  contacts: 'مخاطبین',
  calls: 'تماس‌ها',
  settings: 'تنظیمات',
  logout: 'خروج',
  newMessage: 'پیام جدید',
  typeMessage: 'پیام خود را بنویسید...',
  send: 'ارسال',
  startCall: 'تماس صوتی',
  startVideo: 'تماس تصویری',
  endCall: 'پایان تماس',
  mute: 'قطع صدا',
  unmute: 'وصل صدا',
  searchContacts: 'جستجوی نام کاربری...',
  noConversations: 'یک گفتگو را انتخاب کنید',
  userIsTyping: 'در حال نوشتن...',
  online: 'آنلاین',
  offline: 'آفلاین',
  signupSuccess: 'حساب ساخته شد',
  loginSuccess: 'وارد شدید',
  error: 'خطا',
  invalidCredentials: 'نام کاربری یا رمز عبور نادرست است',
  emailAlreadyExists: 'این ایمیل قبلاً ثبت شده است',
  passwordTooShort: 'رمز عبور باید حداقل ۶ حرف باشد',
  noMessages: 'هنوز پیامی نیست',
  sendImage: 'ارسال عکس',
  sendVideo: 'ارسال فیلم',
  uploading: 'در حال ارسال...',
  incomingCall: 'تماس ورودی',
  incomingAudio: 'تماس صوتی',
  incomingVideo: 'تماس تصویری',
  acceptCall: 'پاسخ',
  rejectCall: 'رد کردن',
  calling: 'در حال تماس…',
  connecting: 'در حال اتصال…',
  inCall: 'متصل شدید',
  remoteUser: 'مخاطب',
  familySubtitle: 'آشیانه — گفت‌وگو با خانواده، بدون شلوغی.',
  familyPitch: 'پیام خصوصی، عکس و تماس تصویری — فقط برای کسانی که به آن‌ها اعتماد دارید.',
  privateNote: 'برای یک خانواده کوچک ساخته شده، نه برای همه.',
  showPassword: 'نمایش رمز',
  hidePassword: 'پنهان کردن رمز',
  back: 'بازگشت',
  emptyListHint: 'نام کاربری را جستجو کنید تا گفتگو شروع شود.',
  signupRestricted: 'ثبت‌نام فقط برای اعضای خانواده است',
  emailPlaceholder: 'ایمیل خود را بنویسید',
  username: 'نام کاربری',
  usernamePlaceholder: 'نام کاربری',
  goodMorning: 'صبح بخیر',
  goodAfternoon: 'ظهر بخیر',
  goodEvening: 'عصر بخیر',
  goodNight: 'شب بخیر',
  familyHero: 'گفت‌وگوی خصوصی با خانواده',
  openChat: 'باز کردن گفتگو',
  imageMessage: 'عکس',
  videoMessage: 'فیلم',
  close: 'بستن',
  cameraDenied: 'دسترسی به دوربین یا میکروفون داده نشد',
  waitingForPeer: 'منتظر طرف مقابل…',
  newMessageTitle: 'پیام جدید',
  incomingCallTitle: 'تماس ورودی',
  enableNotifications: 'اجازه اعلان‌ها',
  enableNotificationsHint: 'برای پاپ‌آپ تماس و پیام، این دکمه را بزنید',
  pushDenied:
    'اجازه داده نشد. در تنظیمات آیفون، اعلان را برای آشیانه روشن کنید یا آیکون صفحه اصلی را پاک کنید و دوباره اضافه کنید.',
  pushInsecure: 'اعلان پس‌زمینه روی این آدرس امن نیست؛ دامنه لازم است',
  pushNeedsDomain: 'اعلان پس‌زمینه روی این آدرس امن نیست؛ دامنه لازم است',
  pushAddToHome:
    'اول از سافاری روی HTTPS دکمه Share را بزنید، Add to Home Screen را انتخاب کنید، برنامه را از آیکون صفحه اصلی باز کنید، بعد دوباره «اجازه اعلان‌ها» را بزنید.',
  pushUnsupported: 'این مرورگر اعلان را پشتیبانی نمی‌کند. از سافاری روی آیفون ۱۶.۴ یا جدیدتر استفاده کنید.',
  pushFailed: 'ثبت اعلان انجام نشد. از آیکون صفحه اصلی باز کنید و دوباره بزنید.'
};

const apiErrorMap = {
  'Email already registered': translations.emailAlreadyExists,
  'Invalid credentials': translations.invalidCredentials,
  'Signup failed': translations.error,
  'Login failed': translations.invalidCredentials,
  'Signup is restricted to invited family members': translations.signupRestricted,
  'Password must be at least 6 characters': translations.passwordTooShort,
  'Query too short': translations.error,
  'Search failed': translations.error,
  'Upload failed': translations.error,
  'Failed to upload file': translations.error,
  'Failed to send message': translations.error,
  'conversationId and content are required': translations.error,
  'conversationId and file are required': translations.error,
  'Not a conversation participant': translations.error,
  'Cannot start conversation with yourself': translations.error,
  'File too large': translations.error,
  'Only images and videos are allowed': translations.error
};

export function translateApiError(message) {
  if (!message) return translations.error;
  if (apiErrorMap[message]) return apiErrorMap[message];
  if (translations[message]) return translations[message];
  if (/[A-Za-z]/.test(message) && !/[\u0600-\u06FF]/.test(message)) {
    return translations.error;
  }
  return message;
}
